import PrimaryButton from "../PrimaryButton";
import { useTranslation } from "react-i18next";
import { registerOTP } from "../../apis/otp";
import { convertPhoneNumber } from "../../utils/phone-number";

export default function SignupButton({
  errorPhone = null,
  setErrorPhone = null,
  phoneValue = null,
  setUserId = null,
  setShowZaloOAuth = null,
}) {
  const { t } = useTranslation();

  const handleSendOTP = async () => {
    if (setErrorPhone) {
      if (errorPhone === "" && phoneValue !== "") {
        phoneValue = convertPhoneNumber(phoneValue);
        const result = await registerOTP(phoneValue);

        if (result.data.userId) setUserId(result.data.userId);
        console.log(result);
        if (result.status === 200) {
          setShowZaloOAuth(true);
        } else {
          setErrorPhone(result.msg);
        }
      } else {
        setErrorPhone("invalid_phone");
      }
    }
  };
  return <PrimaryButton text={t("signup")} onClick={handleSendOTP} />;
}
